module.exports = __parcel__import__.meta.resolve("hS1Yr");